'use strict';

var _ = require('lodash');
var AdvancedGridReloadConfigurationCacheService = function AdvancedGridReloadConfigurationCacheService(foMarketsService) {
  function reloadConfigurationCacheForMode(mode) {
    switch (mode) {
      case 'fo-markets':
        foMarketsService.loadFoMarkets();
        break;
    }
  }
  function reloadMarkets() {
    foMarketsService.loadFoMarkets();
  }
  return {
    reloadConfigurationCacheForMode: reloadConfigurationCacheForMode,
    reloadMarkets: reloadMarkets
  };
};
AdvancedGridReloadConfigurationCacheService.$inject = ['FOMarketsService'];
module.exports = AdvancedGridReloadConfigurationCacheService;